// Uclean-Admin-Dashboard/src/mocks/promo/_shared/ownership.js
// Doc §5.2: platform proxy forces owner_type=platform, owner_id=null
// regardless of what the client sends. No 4xx — silent override.

export function forcePlatformOwner(body) {
  return { ...body, owner_type: 'platform', owner_id: null };
}
